module.exports = __webpack_public_path__ + "static/media/thewest-digital-hero.5a8086da.jpg";